import { useState, useEffect, useRef } from "react";
import { CATEGORIES } from "@/data/menuData";

export const CategoryNav = ({ activeCategory }) => {
  const [isSticky, setIsSticky] = useState(false);
  const navRef = useRef(null);
  const sentinelRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: "-1px 0px 0px 0px" }
    );
    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToCategory = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (activeCategory && navRef.current) {
      const activeBtn = navRef.current.querySelector(`[data-cat="${activeCategory}"]`);
      if (activeBtn) {
        activeBtn.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    }
  }, [activeCategory]);

  return (
    <>
      <div ref={sentinelRef} className="h-0" />
      <nav
        ref={navRef}
        data-testid="category-nav"
        className={`sticky top-0 z-50 transition-shadow duration-300 ${
          isSticky
            ? "bg-[#E8E8E8]/85 backdrop-blur-xl border-b border-[#1A1A1A]/10 shadow-[0_4px_20px_rgba(0,0,0,0.08)]"
            : "bg-[#E8E8E8]"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex gap-2 py-3 overflow-x-auto scrollbar-hide">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                data-cat={cat.id}
                data-testid={`category-btn-${cat.id}`}
                onClick={() => scrollToCategory(cat.id)}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-['DM_Sans'] font-semibold whitespace-nowrap transition-colors duration-300 ${
                  activeCategory === cat.id
                    ? "bg-[#556B2F] text-white shadow-md"
                    : "bg-white/60 text-[#333333] hover:bg-[#556B2F]/10 hover:text-[#556B2F]"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
};
